import { Loader } from '../../../../shared/components/Loader';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Typography, Divider, Button, Box, IconButton } from '@mui/material'
import * as Icon from '@mui/icons-material/';
import useMaquinaConsultar from '../../../../hooks/useMaquinaConsultar';
import DataTable from '../../../../shared/components/Table/index';
import { GridColDef } from '@mui/x-data-grid';
import { useParams } from 'react-router-dom';
import { TextField } from '@mui/material';

export default function MaquinaConsultar() {
  const { id } = useParams();
  const MaquinaId = id ? parseInt(id) : undefined;
  console.log(id);

  const {
    handleNavigate,
    values,
  } = useMaquinaConsultar(MaquinaId);

  const COLUMNS: GridColDef[] = [
    {
      field: 'actions',
      headerName: 'Ações',
      headerAlign: 'center',
      align: 'center',
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const OS_id = params.row.OS_id;
        return (
          <IconButton onClick={() => handleNavigate(OS_id)} color="primary">
            <Icon.Search />
          </IconButton>
        );
      },
    },
    {
      field: 'OS_id',
      headerName: 'Ordem Serviço ID',
      headerAlign: 'center',
      align: 'center',
      width: 200,
      disableColumnMenu: true,
    },
    {
      field: 'dataInclusao',
      headerName: 'Data Inclusão',
      headerAlign: 'center',
      align: 'center',
      width: 200,
    },
    {
      field: 'dataEntrega',
      headerName: 'Data Entrega',
      headerAlign: 'center',
      align: 'center',
      width: 200,
    },
    {
      field: 'OS_status',
      headerName: 'Status',
      headerAlign: 'center',
      align: 'center',
      width: 200,
    },
    {
      field: 'nomeResponsavel',
      headerName: 'Nome Responsável',
      headerAlign: 'center',
      align: 'center',
      width: 300,
    }
  ]

  return (
    <Loader loading={false}>
      <HeaderComponent text='Ordens de Serviço da Máquina' />
      <Box className='p-3 grid grid-cols-6 gap-3'>
        <TextField
          className="col-span-1"
          label='Máquina'
          name='Maquina'
          value={MaquinaId}
          disabled={true}
        />
        <TextField
          className="col-span-5"
          label='Nome da Máquina'
          name='Descricao'
          value={values.prod_descricao}
          disabled={true}
        />
      </Box>
      <Box className='col-span-12 py-4 pt-4'>
        <div className='flex justify-center'>
          <Typography variant="h6" component="h2" className='col-span-6 gap-left-8'>
            Ordem de Serviços Relacionadas
          </Typography>
        </div>
        <Divider className={'col-span-12'} />
        <DataTable
          hideFooter={true}
          height={'25vh'}
          columns={COLUMNS}
          rows={Array.isArray(values?.ordemServico)
            ? values.ordemServico.map((item: any, index: number) => ({
              ...item,
              id: index,
            }))
            : []}
          showFilter={false}
          showButtonToXlsx={false}
        />
      </Box>
      <Box className='p-3 grid grid-cols-6 gap-3'>
        <Button
          className='!px-6 col-span-1'
          onClick={() => history.back()}
          variant='contained'
          color='primary'
          startIcon={<Icon.ArrowBack />}
        >
          Voltar
        </Button>
      </Box>
    </Loader>);
}



